import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { clearValue, setBooking, setDelivery, setPhone2, setPhone3, setStep } from "../../../Reducer/bookingSlice"
import Handler from "../../../Helpers/Components/Handler";
import { reloadWindowToPath } from "../../../Helpers/Utils";
import Modal from "../../../Helpers/Components/Modal";
import { toast } from "react-toastify";
import CustomerEdit from "./CustomerEdit";
import Vehicle from "./Vehicle"
import Trip from "./Trip";
import Payment from "./Payment";
import Booking from "./Booking";
import { useAuth } from "../../../Contexts/AuthenticateProvider";

const Delivery = () => {
    const { id } = useParams()
    const [bookingId, setBookingId] = useState("")
    const [loading, setLoading] = useState(false)
    const booking = useSelector(state => state.booking.booking)
    const step = useSelector(state => state.booking.step)
    const [preview, setPreview] = useState(false)
    const [leadList, setLeadList] = useState([])
    const navigate = useNavigate()
    const { userDetails } = useAuth()
    const [prev, setPrev] = useState({ delivery: 0, pickup: 0, securityDeposit: 0 })
    const [expiryConfirm, setExpiryConfirm] = useState({ open: false, message: "" })
    const dispatch = useDispatch()
    const getLeadList = async () => {
        const response = await Handler({ method: "get", url: `/booking/lead-list`, })
        if (response?.success) {
            const lead = response?.data
            if (lead?.length) {
                const stageHistory = booking.stageHistory?.length ? booking.stageHistory?.find(element => element.stage === "Ongoing") : ""
                // let delivered = stageHistory?.staffId || ""
                // let deliveryBy = delivered || userDetails?.id || userDetails?.adminId
                const filteredLead = lead?.filter(element => element?.leadId !== userDetails?.id && element?.leadId !== userDetails?.adminId)
                const ourName = lead?.find(element => element?.leadId === userDetails?.id || element?.leadId === userDetails?.adminId)
                // if (booking?.deliveryBy !== deliveryBy) {
                //     dispatch(setBooking({ deliveryBy }));
                // }
                setLeadList([...(ourName ? [{ label: ourName?.name?.toUpperCase(), value: ourName?.leadId }] : []), ...(filteredLead?.length ? filteredLead?.map((element) => { return { label: element?.name?.toUpperCase(), value: element?.leadId } }) : [])])
            } else {
                setLeadList([])
            }
        } else {
            setLeadList([])
        }
    }
    const getBookingDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: 'get', url: `/booking/detail/${id}` })
        setLoading(false)
        if (response?.success) {
            const data = response?.data
            if (!data?.customer?.custStatus) {
                toast.error("Customer is deactive")
            }
            const mobileStatus = data?.customer?.custType === "local" ? (data?.customer?.phone?.length ? data?.customer?.phone?.filter((phone) => phone?.status)?.length >= 3 : false) : (data?.customer?.phone?.length ? data?.customer?.phone?.filter((phone) => phone?.status)?.length >= 2 : false)
            if (!mobileStatus || (data?.customer?.type === "Online" && data?.customer?.status !== "Verified")) {
                navigate(`/customer/booking/update/${data?.customer?.customerId}/${id}`);
            }
            dispatch(setBooking({ ...response?.data?.booking, car: data?.car, carId: data?.booking?.carId, customer: data?.customer, firstName: data?.customer?.firstName, lastName: data?.customer?.lastName, phone: data?.customer?.phone?.length ? data?.customer?.phone?.filter(e => e.priority === 1)?.length ? data?.customer?.phone?.filter(e => e.priority === 1)[0] : {} : {} }))
            setPrev({ delivery: response?.data?.booking?.deliveryDetails?.price, pickup: response?.data?.booking?.pickupDetails?.price, securityDeposit: response?.data?.booking?.securityDeposit })
            if (data?.booking?.deliveryDetails?.delivery && data?.booking?.pickupDetails?.pickup) {
                let diff = ((new Date(data?.booking?.pickupDetails?.pickup).getTime() - new Date(data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600;
                if (Math.ceil(diff / 12) / 2 == 0.5) {
                    dispatch(setBooking({ totalDays: 1, halfDayOffer: 0, point: 0 }))
                } else {
                    dispatch(setBooking({ totalDays: Math.floor(Math.ceil(diff / 12) / 2) }));
                    if (Math.ceil(diff / 12) % 2 !== 0) {
                        let to = new Date(data?.booking?.pickupDetails?.pickup)
                        to?.setHours(new Date(data?.booking?.pickupDetails?.pickup)?.getHours() - 2)
                        let diff1 = ((to?.getTime() - new Date(data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600
                        if (Math.ceil(diff1 / 12) % 2 !== 0) {
                            dispatch(setBooking({ point: 0.5 }))
                        } else {
                            dispatch(setBooking({ point: 0, halfDayOffer: 0 }))
                        }
                    } else {
                        dispatch(setBooking({ point: 0, halfDayOffer: 0 }))
                    }
                }
            }
            dispatch(setPhone2(data?.customer?.phone?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 2)?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 2)[0] : {} : {}))
            dispatch(setPhone3(data?.customer?.phone?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 3)?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 3)[0] : {} : {}))
            dispatch(setStep(Number(response?.data?.booking?.screenEdit) > 4 ? 0 : Number(response?.data?.booking?.screenEdit)))
        } else {
            reloadWindowToPath(`/booking/1`)
        }
    }
    const handleSubmit = async (confirmExpiry = false) => {
        setLoading(true)
        const response = await Handler({ method: 'patch', url: `/booking/delivery/fifth/update/${bookingId}`, data: { proofCollected: booking?.proofCollected, ...(confirmExpiry ? { confirmExpiry: true } : {}) } })
        if (response?.success) {
            setExpiryConfirm({ open: false, message: "" })
            setTimeout(() => {
                reloadWindowToPath(`/booking/1`)
            }, 1500);
            toast.success(response?.message)
        } else if (response?.message?.includes("Confirm to proceed")) {
            setLoading(false)
            setExpiryConfirm({ open: true, message: response?.message })
        } else {
            setLoading(false)
            toast.error(response?.message)
        }

    }
    const updateSteps = async () => await Handler({ method: 'PATCH', url: `/booking/change/screen/${bookingId}?step=${step}`, data: {} })
    useEffect(() => {
        let totalAmount =
            ((Number(booking?.rentalFee || 0) -
                Number(booking?.offerPerDay || 0)) * (booking?.totalDays || 0)) +
            Number(booking?.deliveryDetails?.price || 0) + Number(booking?.pickupDetails?.price || 0) +
            Number(booking?.securityDeposit || 0)
        totalAmount += Number(booking?.point) === 0.5 ? (Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0) : 0
        dispatch(setBooking({ balancePaid: totalAmount - Number(booking?.advance?.amount || 0), totalAmount }));
    }, [booking?.rentalFee, booking?.offerPerDay, booking?.totalDays, booking?.deliveryDetails?.price, booking?.pickupDetails?.price, booking?.securityDeposit, booking?.point, booking?.halfDayOffer, booking?.advance?.amount])
    useEffect(() => {
        dispatch(clearValue())
    }, [])
    useEffect(() => {
        if (id) {
            setBookingId(id)
            getBookingDetails()
        }
    }, [id])
    useEffect(() => {
        if (Number(booking?.balancePaid) <= 0) {
            dispatch(setBooking({ balance: [] }))
        }
    }, [booking?.balancePaid])
    const dl = useMemo(
        () => booking?.customer?.kyc?.find(el => el?.type === "dl") || {},
        [booking?.customer?.kyc]
    );

    const aadhaar = useMemo(
        () => booking?.customer?.kyc?.find(el => el?.type === "aadhaar") || {},
        [booking?.customer?.kyc]
    );

    const passport = useMemo(
        () => booking?.customer?.kyc?.find(el => el?.type === "passport") || {},
        [booking?.customer?.kyc]
    );
    useEffect(() => {
        if (userDetails?.id || userDetails?.adminId) {
            getLeadList();
        }
    }, [userDetails, booking?.stageHistory]);
    const initialLoad = useRef(true);
    useEffect(() => {
        if (!bookingId) return;
        if (initialLoad.current) {
            initialLoad.current = false;
            return;
        }
        updateSteps();
    }, [step]);
    return (
        <React.Fragment>
            <div className="arrow-back"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
            <h5 className="text-center text-theme fs-4">Booking Update</h5>
            <h6 className="text-center">Pre Booking - Delivery</h6>
            <div className="layout-card mt-4">
                <div className="inside-fixed">
                    <div className="text-center fs-5 mb-3 fw-bold">Status: {booking?.status}</div>
                    <div className="row">
                        <div className="text-center col-sm-4"><span className="topTitle">Booking ID : </span>{(booking?.bookingId ? booking?.bookingId : "-")}</div>
                        <div className="text-center col-sm-4"><span className="topTitle">Cust ID : </span>{(booking?.customerId ? booking?.customerId : "-")}</div>
                        <div className="text-center col-sm-4"><span className="topTitle">Booked Date : </span>{(booking?.createdAt ? moment(booking?.createdAt)?.format("DD/MM/YYYY") : "-")}</div>
                    </div>
                    <hr className="mb-5" />
                </div>
                <div className="row">
                    <div className="col-lg-3 d-lg-block d-flex justify-content-between mb-lg-0 mb-4 tab-col">
                        <div className="d-flex align-items-center gap-2">
                            <span className={`${step === 0 ? "active-tab" : (step > 0 ? "completed-tab" : "")} round-span`}>{step > 0 ? <i className="fa-solid fa-check"></i> : "1"}</span>
                            <div className={`register-tabs d-lg-block d-none`}>Customer Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2 my-lg-4 my-0">
                            <span className={`${step === 1 ? "active-tab" : (step > 1 ? "completed-tab" : "")} round-span`}>{step > 1 ? <i className="fa-solid fa-check"></i> : "2"}</span>
                            <div className="register-tabs d-lg-block d-none">Vehicle Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2 my-lg-4 my-0">
                            <span className={`${step === 2 ? "active-tab" : (step > 2 ? "completed-tab" : "")} round-span`}>{step > 2 ? <i className="fa-solid fa-check"></i> : "3"}</span>
                            <div className="register-tabs d-lg-block d-none">Trip Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 3 ? "active-tab" : (step > 3 ? "completed-tab" : "")} round-span`}>{step > 3 ? <i className="fa-solid fa-check"></i> : "4"}</span>
                            <div className="register-tabs d-lg-block d-none">Payment Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 4 ? "active-tab" : (step > 4 ? "completed-tab" : "")} round-span`}>{step > 4 ? <i className="fa-solid fa-check"></i> : "5"}</span>
                            <div className="register-tabs d-lg-block d-none">Booking Info</div>
                        </div>
                    </div>
                    <div className="col-lg-9">
                        {
                            step === 0 ?
                                <CustomerEdit bookingId={bookingId} />
                                : step === 1 ?
                                    <Vehicle leadList={leadList} bookingId={bookingId} />
                                    : step === 2 ?
                                        <Trip bookingId={bookingId} />
                                        : step === 3 ?
                                            <Payment bookingId={bookingId} prev={prev} />
                                            : step === 4 ?
                                                <Booking leadList={leadList} bookingId={bookingId} dl={dl} passport={passport} aadhaar={aadhaar} setPreview={setPreview} />
                                                : ""
                        }
                    </div>
                </div>
            </div>
            <Modal fullScreen={"true"} header="Preview" size={'lg'} onShow={preview} footerClassname={'justify-content-center'} toggle={() => setPreview(false)} overlayToggle={() => setPreview(false)}>
                <div className="row justify-content-center mb-3 align-items-stretch">
                    <div className="row px-3">
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Customer ID </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={booking?.customerId} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Customer Name </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.firstName || "") + " " + (booking?.lastName || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row px-3">
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Mobile </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.phone?.code || "") + "-" + (booking?.phone?.phone || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Alt Number 1 </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.phone2?.code || "") + "-" + (booking?.phone2?.phone || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Alt Number 2 </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.phone3?.code || "") + "-" + (booking?.phone3?.phone || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row p-3">
                        <div className="col-lg-4">
                            <div className="form_title mb-4 text-center fw-bold"> Trip Info</div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Date and Time: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.delivery ? moment(new Date(booking?.deliveryDetails?.delivery))?.format("DD/MM/YYYY hh:mm A") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Location: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.location} readOnly />
                                </div>
                            </div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > Pickup Date and Time: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.pickup ? moment(new Date(booking?.pickupDetails?.pickup))?.format("DD/MM/YYYY hh:mm A") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  Pickup Location: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.location} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Package: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.package} readOnly />
                                </div>
                            </div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > Start KM: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.km?.start || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  Start Fuel: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.fuel?.start || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  Start Fastag: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.fastTag?.start || 0} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="mt-3 mt-lg-0 col-lg-4">
                            <div className="form_title mb-3 text-center fw-bold"> Payment Info</div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Total Days: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.totalDays + booking?.point} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Cost per day: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={(Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0)) || 0} readOnly />
                                </div>
                            </div>
                            {
                                booking?.point === 0.5 ?
                                    <div className="row mb-3">
                                        <label className="col-sm-5 col-form-label" > Half day rent: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={((Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0)) || 0} readOnly />
                                        </div>
                                    </div> : ""
                            }
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Total Cost: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={
                                        (booking?.totalDays * (Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0))) + (booking?.point === 0.5 ? (Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0) : 0) || 0
                                    } readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Charge: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.price || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Pickup Charge: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.price || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Security Deposit: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.securityDeposit || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Advance Paid: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.paid || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Advance Paid Mode: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.mode || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3 d-flex align-items-center">
                                <label className="col-sm-5 col-form-label" > Advance Paid Remarks: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.remarks || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Balance to be Paid: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.balancePaid || 0} readOnly />
                                </div>
                            </div>
                            {
                                booking?.balance?.length ?
                                    booking?.balance?.map((element, i) => {
                                        return (
                                            <div key={i}>
                                                <div className="row mb-3">
                                                    <label className="col-sm-5 col-form-label" > Balance Amount {i + 1}: </label>
                                                    <div className="col-sm-7">
                                                        <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={element?.amount || 0} readOnly />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-5 col-form-label" > Balance Paid Mode: </label>
                                                    <div className="col-sm-7">
                                                        <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={element?.mode || ""} readOnly />
                                                    </div>
                                                </div>
                                                <div className="row mb-3 d-flex align-items-center">
                                                    <label className="col-sm-5 col-form-label" > Balance Paid Remarks: </label>
                                                    <div className="col-sm-7">
                                                        <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={element?.remarks || ""} readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : ""
                            }
                        </div>
                        <div className="mt-3 mt-lg-0 col-lg-4">
                            <div className="form_title mb-3 text-center fw-bold"> Vehicle Info</div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Car ID: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.carId || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Model: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.model || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Color: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.color || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Reg No: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.registrationNo || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Fastag Bank: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.fasTagType || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Type of Car:</label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.segment || ""} readOnly />
                                </div>
                            </div>
                            <div className="form_title mb-4 text-center fw-bold"> Booking Info</div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Lead Mode: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.lead?.mode} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Lead Attended By: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.lead?.name || booking?.lead?.staffId || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Booking Given By: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.createdBy} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-100 text-center">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> DL  </div> </div>
                                    <div className="col"><div className={dl?.id ? "card-text" : "red card-text"}>  {dl?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : dl?.id ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> DL Photo </div> </div>
                                    <div className="col"><div className={dl?.photo?.length ? "card-text" : "red card-text"}>  {dl?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : dl?.photo?.length ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Aadhaar  </div> </div>
                                    <div className="col"><div className={aadhaar?.id ? "card-text" : "red card-text"}>  {aadhaar?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : aadhaar?.id ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Aadhaar Photo </div> </div>
                                    <div className="col"><div className={aadhaar?.photo?.length ? "card-text" : "red card-text"}>  {aadhaar?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : aadhaar?.photo?.length ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Passport </div> </div>
                                    <div className="col"><div className={passport?.id ? "card-text" : "red card-text"}>  {passport?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : passport?.id ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Passport Photo </div> </div>
                                    <div className="col"><div className={passport?.photo?.length ? "card-text" : "red card-text"}>  {passport?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : passport?.photo?.length ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                        </div>
                        <button className="btn btn-success" disabled={loading} onClick={() => handleSubmit()}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Submit"}</button>
                    </div>
                </div>
            </Modal>
            <Modal header={"Document Expired"} centered={true} onShow={expiryConfirm?.open} toggle={() => setExpiryConfirm({ open: false, message: "" })} overlayToggle={() => setExpiryConfirm({ open: false, message: "" })}>
                <div className="p-3 text-center">
                    <p className="mb-4">{expiryConfirm?.message}</p>
                    <div className="d-flex justify-content-center gap-2">
                        <button className="btn btn-theme" disabled={loading} onClick={() => handleSubmit(true)}>Yes, Proceed Anyway</button>
                        <button className="btn btn-danger" disabled={loading} onClick={() => setExpiryConfirm({ open: false, message: "" })}>Cancel</button>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default Delivery;